import React from 'react';
import { IContentHeaderProps } from '../../types/contentHeader';
import Typography from '../typography/Typography';
import ChevronIcon from '../icons/ChevronIcon';
import './contentHeader.scss';

export const ContentHeader: React.FC<IContentHeaderProps> = ({
  bookingLink,
  bookingLinkText,
  bookingCode,
  title,
  children,
  classes,
  backgroundColor = '#fffaeb',
  noImage = false,
}) => {
  const classBase = 'custom-content-header';
  const ContentHeaderCustomStyles = {
    '--background-color': backgroundColor,
  } as React.CSSProperties;

  return (
    <div
      className={`${classBase} ${classes || ''} ${noImage ? 'bg-img-none' : ''}`}
      data-testid={classBase}
      style={ContentHeaderCustomStyles}
    >
      {
        bookingLink && bookingLinkText && (
          <div className="booking-link-container">
            <ChevronIcon height={16} color="asphalt5" direction="left" />
            <a className="link" href={bookingLink}>{bookingLinkText}</a>
          </div>
        )
      }
      <div className="title-container">
        <Typography
          color="dark"
          variant="h4"
          className="d-flex align-center"
        >
          {title}
        </Typography>
      </div>
      <div className="booking-code-container">
        <Typography
          color="asphalt5"
          variant="body1"
          className="d-flex align-center"
        >
          {bookingCode}
        </Typography>
        <div className="bottom-header-content">
          {children}
        </div>
      </div>
    </div>
  );
};
